import { TopicActionsSection } from '@communities/content-management/components';
import { ActionAuthenticationSection } from '@communities/content-management/components/ActionAuthenticationSection';
import type { EntityType, WorkflowType } from '@communities/content-management/domain';
import { isCommunity } from '@communities/content-management/utils';
import { FEATURE_FLAGS } from '@core/domain';
import { useIsFeatureEnabled } from '@core/hooks';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Section } from '@soteria/design-system-ve';

import { ActionsTab } from './ActionsTab';
import * as styles from './ClassificationTab.css';
import { PoliciesTab } from './PoliciesTab';
import { TopicsTab } from './TopicsTab';

interface ClassificationTabProps {
  entityId: string;
  entityType: EntityType;
  workflowType: WorkflowType;
  isEntityAdmin: boolean;
}

function ClassificationTabComponent({ entityId, entityType, workflowType, isEntityAdmin }: ClassificationTabProps) {
  // Check if callback authentication feature is enabled
  const isCallbackAuthEnabled = useIsFeatureEnabled(FEATURE_FLAGS.CALLBACK_AUTHENTICATION);

  return (
    <div className={styles.tabContainer}>
      {/* Topics Section */}
      <TopicsTab entityId={entityId} entityType={entityType} isEntityAdmin={isEntityAdmin} />

      {/* Policies Section */}
      <PoliciesTab communityId={entityId} isEntityAdmin={isEntityAdmin} workflowType={workflowType} />

      {/* Actions & Callbacks Section */}
      <ActionsTab entityId={entityId} entityType={entityType} isEntityAdmin={isEntityAdmin} workflowType={workflowType} />

      {/* Workflows Section - Topic Actions */}
      <Section spacing="medium">
        <TopicActionsSection entityId={entityId} entityType={entityType} isEntityAdmin={isEntityAdmin} workflowType={workflowType} />
      </Section>

      {/* Callback Auth Settings Section (Only for Communities and when feature flag is enabled) */}
      {isCommunity(entityType) && isCallbackAuthEnabled && <ActionAuthenticationSection />}
    </div>
  );
}

export const ClassificationTab = withAppInsightsTracking(ClassificationTabComponent, 'ClassificationTab');
